import { GroupViewModel } from '../view-models/group.view-model'
import { CartModalManager } from './cart-modal.manager'
import { PricingPlanView } from './pricing-plan.view'

export class PricingTableView {
  protected pricingViews: PricingPlanView[] = []

  constructor(
    tableEl: HTMLElement,
    groupViewModel: GroupViewModel,
    modalManager: CartModalManager,
    TOKEN: string
  ) {
    const loadMorePricingOptions = tableEl.querySelector(
      '.js-load-more-pricing-option'
    )
    const productModels = groupViewModel.makeModels(tableEl, TOKEN)

    loadMorePricingOptions?.addEventListener('click', (event) => {
      event.preventDefault()
      this.loadMorePricingOptions()
    })

    productModels.forEach(([model, widget]) => {
      this.pricingViews.push(
        new PricingPlanView(model, widget, modalManager, groupViewModel)
      )
    })
  }

  private loadMorePricingOptions() {
    this.pricingViews.forEach((view) => view.toggleVisibility())
  }
}
